"use client";

import {
  IconBrandDiscord,
  IconBrandFacebook,
  IconBrandGithub,
  IconBrandInstagram,
  IconBrandLinkedin,
  IconBrandMedium,
  IconBrandReddit,
  IconBrandTelegram,
  IconBrandTiktok,
  IconBrandTwitter,
  IconBrandYoutube,
  IconMail,
  IconPhone,
  IconWorld,
} from "@tabler/icons-react";
import type React from "react";

export interface SocialIconProps
  extends Omit<React.ComponentProps<typeof IconBrandTelegram>, "ref" | "name"> {
  name: string | null | undefined;
  className?: string;
}

// Map social link names to icon components (exact names from social-link.utils.ts)
const getSocialIconComponent = (name: string | null | undefined) => {
  if (!name) return null;

  const normalizedName = name.trim();

  switch (normalizedName) {
    case "Twitter":
      return IconBrandTwitter;
    case "Discord":
      return IconBrandDiscord;
    case "Telegram":
      return IconBrandTelegram;
    case "Instagram":
      return IconBrandInstagram;
    case "Facebook":
      return IconBrandFacebook;
    case "LinkedIn":
      return IconBrandLinkedin;
    case "YouTube":
      return IconBrandYoutube;
    case "TikTok":
      return IconBrandTiktok;
    case "Reddit":
      return IconBrandReddit;
    case "Medium":
      return IconBrandMedium;
    case "GitHub":
      return IconBrandGithub;
    case "Phone":
      return IconPhone;
    case "Email":
      return IconMail;
    case "Website":
      return IconWorld;
    default:
      return null;
  }
};

export const SocialIcon: React.FC<SocialIconProps> = ({
  name,
  className,
  ...iconProps
}) => {
  const IconComponent = getSocialIconComponent(name);

  if (!IconComponent) {
    return null;
  }

  return <IconComponent className={className} {...iconProps} />;
};
